/**
 * «Тихий учитель» (docs/PATH-V2.md §7.1) — the only help of a quiet path game, so it is recorded with the slice like
 * every other path line. Core `coach/lesson/quiet.ts` picks a wording and puts `say: [{ pool, n }]` on the event.
 *
 * The wordings do NOT name the piece: the board shows it (a red dot on the own piece, a green mark on the gift), so
 * one short pool serves every piece (`when` absent) — a per-piece pool would multiply the recording for no new idea.
 * A wording is ADDED, never edited once recorded. Glossary §3.2: «под ударом» (an own piece in danger), «подарок /
 * даром»; no squares in speech; ≤ 2 sentences.
 *
 * Pools:
 * - `v3.path.quiet.danger` — an own piece (knight, bishop, rook, queen) can be taken as a gift (red dot on it);
 * - `v3.path.quiet.gift` — the child has a gift capture: an invitation without an arrow (no piece named);
 * - `v3.path.quiet.reveal` — «Подсказка» after the invitation shows the gift (green mark on it).
 */
import type { PieceType } from '@gambit/shared';
import type { LessonWording } from '../teaching/types.ts';

export const QUIET_POOL = {
  danger: 'v3.path.quiet.danger',
  gift: 'v3.path.quiet.gift',
  reveal: 'v3.path.quiet.reveal',
} as const;

/** Pieces a danger moment is about (own pieces worth ≥ 3) and pieces a gift can be (the words name none of them). */
export const QUIET_DANGER_PIECES: readonly PieceType[] = ['n', 'b', 'r', 'q'];
export const QUIET_GIFT_PIECES: readonly PieceType[] = ['p', 'n', 'b', 'r', 'q'];

export const PATH_QUIET_LINES: Record<string, LessonWording[]> = {
  [QUIET_POOL.danger]: [
    { t: 'Ой, твоя фигура под ударом! Как её спасти?' },
    { t: 'Стоп! Эту фигуру могут забрать даром.' },
    { t: 'Посмотри: твоя фигура под ударом!' },
  ],
  [QUIET_POOL.gift]: [
    { t: 'Посмотри внимательно… кажется, здесь есть подарок!' },
    { t: 'Посмотри внимательно: соперник что-то оставил даром.' },
    { t: 'Посмотри внимательно на доску. Нет ли подарка?' },
  ],
  [QUIET_POOL.reveal]: [{ t: 'Вот он, подарок! Его можно взять даром.' }, { t: 'Смотри: вот подарок соперника!' }],
};
